/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q8Inputs */

const et_faq_q8 = /** @type {(inputs: Faq_Q8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuidas automatiseerida müügiprotsesse AI abil?`)
};

const en_faq_q8 = /** @type {(inputs: Faq_Q8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How can I automate sales processes with AI?`)
};

/**
* | output |
* | --- |
* | "How can I automate sales processes with AI?" |
*
* @param {Faq_Q8Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q8 = /** @type {((inputs?: Faq_Q8Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q8Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q8(inputs)
	return en_faq_q8(inputs)
});